import {handleLogout} from "components/utils"; import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, Col, Form, Row, Table} from "react-bootstrap";
import DatePicker from "react-datepicker";
import axios from "axios";
import {formatDate, formatDateToLocale, formatDateToStandard, randomString, validatePhoneNumber} from "../utils";
import {Typeahead} from "react-bootstrap-typeahead";
import {PatientDetailsView} from "../customer/category/PatientDetailsView";
import {PatientPreconditionsView} from "../customer/category/PatientPreconditionsView";
import {CustomTypeahead} from "../common/CustomTypeahead";

export const CaseDetailsView = (props: { cookieEntityQr: string, caseNumber: string, postAction: any, doctors: Array<any>, createForUhid: string }) => {

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [caseDetailsJson, setCaseDetailsJson] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [packages, setPackages] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState([]);
    const [insurances, setInsurances] = useState<Array<any>>([]);
    const [uhid, setUhid] = useState(null);
    const [events, setEvents] = useState([])
    const [diagnosisList, setDiagnosisList] = useState([])
    const childRef = useRef(null);

    function fetchInsurances() {
        axios.get('/api/backend/ipd/insurance/provider/fetch/all/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (resp.data) {
                    setInsurances(resp.data)
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function fetchDiagnosisList() {
        axios.get('/api/backend/patient/condition/' + props.cookieEntityQr + '/DIAGNOSIS')
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setDiagnosisList(resp.data.map(v => v.name))
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }
    const handleAddDiagnosis = (condition) => {
        axios.post('/api/backend/patient/condition/create/' + props.cookieEntityQr, {
            name: condition,
            type: "DIAGNOSIS",
            category: "General Physician"
        })
            .then(resp => {
                console.log(JSON.stringify(resp.data))
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                setErrorMessage("* Something went wrong!")
            })
    };

    const [file, setFile] = useState<any>();
    let componentRef = useRef(null);

    const handleFileChange = event => {
        setErrorMessage(null)
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB")
            } else {
                setFile(selectedFile);
            }
        }
    };

    function fetchCase() {
        axios.get('/api/backend/ipd/case/fetch/' + props.cookieEntityQr + "/" + props.caseNumber)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setFormData(resp.data)
                if(resp.data.caseDetails) setCaseDetailsJson(JSON.parse(resp.data.caseDetails))
                setUhid(resp.data.uhid)
                setSelectedPackage(packages.filter(p => p.id == resp.data.packageId))
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function fetchPackages() {
        axios.get('/api/backend/packages/entity_qr/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (resp.data) {
                    setPackages(resp.data)
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    const uploadFile = async () => {
        let key = props.cookieEntityQr + "_" + randomString() + "_" + file.name
        let {data} = await axios.post("/api/s3/upload", {
            name: key,
            type: file.type,
        });

        console.log(data);

        const url = data.url;
        let {data: newData} = await axios.put(url, file, {
            headers: {
                "Content-type": file.type,
                "Access-Control-Allow-Origin": "*",
            },
        });

        console.log(newData);

        return key
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        setErrorMessage(null)
        setSuccessMessage(null)
        childRef.current.handleDataSubmit()

    };

    function postAction(uhid) {
        if (file) {
            uploadFile()
                .then(resp => {
                    console.log(resp)
                    saveData(resp, uhid)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                    setErrorMessage("Error while uploading the file")
                    setLoading(false)
                })
        } else {
            saveData(null, uhid)
        }
        saveEvents(uhid)
    }

    function saveEvents(uhid) {
        if (uhid != null && events != null) {
            axios.post('/api/backend/customers/save/' + uhid + '/events', events)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        } else {
            setErrorMessage("* Please enter the correct details of the patient")
        }
    }

    function saveData(photoIdUrl, uhid) {
        if (formData["accompByNumber"] != null && !validatePhoneNumber(formData["accompByNumber"])) {
            setErrorMessage("Please provide valid phone number")
            setLoading(false)
            return
        }
        if (props.caseNumber) {
            axios.post('/api/backend/ipd/case/update/' + formData["id"], {
                ...formData,
                caseDetails: JSON.stringify(caseDetailsJson),
                entityQr: props.cookieEntityQr,
                photoIdUrl: photoIdUrl,
                paymentMode: formData["policyNumber"] ? "INSURANCE" : "SELF",
                photoIdType: formData["photoIdType"] ? formData["photoIdType"] : "AADHAR",
                assignedDr: formData["assignedDr"] ? formData["assignedDr"] : props.doctors[0]["clientName"],
                assignedDrId: formData["assignedDrId"] ? formData["assignedDrId"] : props.doctors[0]["id"],
                packageId: selectedPackage.length > 0 ? selectedPackage[0].id : 0
            })
                .then(resp => {
                    props.postAction()
                    console.log(resp.data)
                    setSuccessMessage("Data Saved")
                })
                .catch(err => {
                    setErrorMessage("Please specify all mandatory fields correctly.")
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                })
                .finally(() => setLoading(false))
        } else {
            axios.post('/api/backend/ipd/case/create', {
                ...formData,
                caseDetails: JSON.stringify(caseDetailsJson),
                uhid: uhid,
                entityQr: props.cookieEntityQr,
                photoIdUrl: photoIdUrl,
                paymentMode: formData["policyNumber"] ? "INSURANCE" : "SELF",
                photoIdType: formData["photoIdType"] ? formData["photoIdType"] : "AADHAR",
                assignedDr: formData["assignedDr"] ? formData["assignedDr"] : props.doctors[0]["clientName"],
                assignedDrId: formData["assignedDrId"] ? formData["assignedDrId"] : props.doctors[0]["id"],
                packageId: selectedPackage.length > 0 ? selectedPackage[0].id : 0
            })
                .then(resp => {
                    props.postAction()
                    console.log(resp.data)
                })
                .catch(err => {
                    setErrorMessage("Please specify all mandatory fields correctly.")
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                })
                .finally(() => setLoading(false))
        }
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handlePatientDetailsChange = (e) => {
        setCaseDetailsJson({
            ...caseDetailsJson,
            [e.target.name]: e.target.value
        });
    };

    const handleDoctorAssigned = (e) => {
        setFormData({
            ...formData,
            "assignedDr": e.target.value.split(" - ")[1],
            "assignedDrId": e.target.value.split(" - ")[0]
        });
    };

    useEffect(() => {
        if (props.caseNumber) {
            fetchCase();
        }
    }, [props.caseNumber, packages])

    useEffect(() => {
        if (props.createForUhid) {
            setUhid(props.createForUhid)
        }
    }, [props.createForUhid])

    useEffect(() => {
        fetchPackages()
        fetchInsurances()
        fetchDiagnosisList()
        setFormData({
            ...formData,
            // Trimming any whitespace
            dob: new Date()
        });
    }, [])


    function getBasicInfo() {
        return <Card>
            <Card.Header className="bg-info bg-opacity-75 fw-bold text-white">Basic Info</Card.Header>
            <Card.Body>
                <PatientDetailsView ref={childRef} category="IPD" uhid={uhid}
                                    postAction={postAction} updateEvents={setEvents}/>
                <div className="row">
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="accompBy">
                            <Form.Label className="fs-7 text-secondary">Accompanying Person&apos;s
                                Name</Form.Label>
                            <Form.Control value={formData['accompBy']} onChange={handleChange} size={"sm"}
                                          name="accompBy"
                                          type="text"
                                          placeholder="Enter Accompanying Person&apos;s Name"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="accompByNumber">
                            <Form.Label className="fs-7 text-secondary">Accompanying Person&apos;s
                                Mobile</Form.Label>
                            <Form.Control value={formData['accompByNumber']} onChange={handleChange} size={"sm"}
                                          name="accompByNumber" type="tel"
                                          placeholder="Enter Accompanying Person&apos;s Mobile"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="type">
                            <Form.Label className="fs-7 text-secondary">Type</Form.Label>
                            <Form.Select className="form-select form-select-sm"
                                         value={formData['photoIdType']}
                                         name="photoIdType"
                                         onChange={e => handleChange(e)}
                            >
                                <option value="AADHAR">AADHAR</option>
                                <option value="DL">DL</option>
                                <option value="PAN">PAN</option>
                                <option value="OTHER">OTHER</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="photoId">
                            <Form.Label className="fs-7 text-secondary">Photo Id</Form.Label>
                            <Form.Control value={formData['photoId']} onChange={handleChange} name="photoId" size={"sm"}
                                          type="text"
                                          placeholder="Enter Id"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="file">
                            <Form.Label className="fs-7 text-secondary">File</Form.Label>
                            <input type="file"
                                   ref={componentRef}
                                   className="form-control form-select form-select-sm"
                                   accept=".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf"
                                   onChange={handleFileChange}/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-md-6 col-lg-4">
                        {formData['photoIdUrl'] &&
                            <Form.Group className="mb-3" controlId="photoIdUrlDownload">
                                <Form.Label className="fs-7 text-secondary">Download</Form.Label><br/>
                                <a target="_blank" rel="noreferrer"
                                   href={"/api/s3/download/?file=" + formData['photoIdUrl']}
                                   className="text-success font-weight-bold"> &#x2193;</a>
                            </Form.Group>
                        }
                    </div>
                </div>
            </Card.Body>
        </Card>;
    }

    function getBillingInfo() {
        return <Card>
            <Card.Header className="bg-info bg-opacity-75 fw-bold  text-white">Billing Info</Card.Header>
            <Card.Body>
                <div className="row">
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="number">
                            <Form.Label className="fs-7 text-secondary">Insurance TPA / Self</Form.Label>
                            <Form.Select className="form-select" size={"sm"}
                                         value={formData['insuranceProviderId']}
                                         name="insuranceProviderId"
                                         onChange={e => handleChange(e)}
                            >
                                <option value={0} key={0}>Self Payment</option>
                                {insurances.map(insurance => {
                                    return <option value={insurance.id}
                                                   key={insurance.id}>{insurance.tpa}</option>
                                })

                                }
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="policyNumber">
                            <Form.Label className="fs-7 text-secondary">Policy Id</Form.Label>
                            <Form.Control value={formData['policyNumber']} onChange={handleChange}
                                          size={"sm"}
                                          name="policyNumber"
                                          type="text"
                                          placeholder="Enter Policy Id"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="packageInfo">
                            <Form.Label className="fs-7 text-secondary">Package Opted</Form.Label>
                            <Typeahead
                                clearButton
                                labelKey="name"
                                size={"sm"}
                                className="flex-fill"
                                onChange={setSelectedPackage}
                                selected={selectedPackage}
                                options={packages}
                                placeholder="Search Package..."
                            />
                        </Form.Group>
                    </div>
                </div>
            </Card.Body>
        </Card>;
    }

    function getMedicalInfo() {
        return <Card>
            <Card.Header className="bg-info bg-opacity-75 fw-bold text-white">Medical Info</Card.Header>
            <Card.Body>
                <div className="row">
                    <div className="col col-12 col-lg-6">
                        <Form.Label className="fs-7 text-secondary">Doctor In-charge<span
                            className="text-danger">*</span></Form.Label>
                        <select className="form-select form-select-sm"
                                value={formData['assignedDrId'] + " - " + formData['assignedDr']}
                                onChange={e => handleDoctorAssigned(e)}
                        >
                            {props.doctors.map(function (profile, index) {
                                return <option key={"docs_" + profile["qrCode"]}
                                               value={profile["id"] + " - " + profile["clientName"]}>{profile["clientName"]}</option>;
                            })}
                        </select>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="purpose">
                            <Form.Label className="text-secondary fs-7">Purpose of Admission</Form.Label>
                            <Form.Control value={formData['purpose']}
                                          onChange={handleChange} size={"sm"}
                                          name="purpose"
                                          placeholder="Enter the purpose for Admission"/>
                        </Form.Group>
                    </div>

                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="cc">
                            <Form.Label className="text-secondary fs-7">Chief Complaints</Form.Label>
                            <Form.Control value={caseDetailsJson["cc"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="cc"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="hpi">
                            <Form.Label className="text-secondary fs-7">History of Present Ilness</Form.Label>
                            <Form.Control value={caseDetailsJson["hpi"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="hpi"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="personal_history">
                            <Form.Label className="text-secondary fs-7">Personal History</Form.Label>
                            <Form.Control value={caseDetailsJson["personal_history"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="personal_history"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="birth_history">
                            <Form.Label className="text-secondary fs-7">Birth/Family History</Form.Label>
                            <Form.Control value={caseDetailsJson["birth_history"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="birth_history"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="drug_allergy">
                            <Form.Label className="text-secondary fs-7">Drug Allergy</Form.Label>
                            <Form.Control value={caseDetailsJson["drug_allergy"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="drug_allergy"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 col-lg-6">
                        <Form.Group className="mb-3" controlId="treatment_history">
                            <Form.Label className="text-secondary fs-7">Treatment History</Form.Label>
                            <Form.Control value={caseDetailsJson["treatment_history"]} as="textarea" rows={6}
                                          onChange={handlePatientDetailsChange} size={"sm"}
                                          name="treatment_history"/>
                        </Form.Group>
                    </div>
                    <div className="col col-12 mb-3">
                        <PatientPreconditionsView entityQr={props.cookieEntityQr}
                                                  category={"General Physician"}
                                                  isEditable={true}
                                                  preconditions={events} labelStyle={"text-secondary fs-7"}
                                                  updatePreconditions={e => {
                                                      setEvents(e)
                                                  }
                                                  } stacked/>
                    </div>
                    <div className="col col-12">
                        <Form.Group className="mb-3" controlId="diagnosis">
                            <Form.Label className="fs-7 text-secondary">Diagnosis</Form.Label>
                            <CustomTypeahead
                                selected={formData['diagnosis'] ? [formData['diagnosis']] : []}
                                onChange={e => {
                                    setFormData({
                                        ...formData,
                                        diagnosis: e[0]
                                    });
                                }}
                                options={diagnosisList}
                                placeholder="Type to select..."
                                size={"sm"}
                                setNewValues={handleAddDiagnosis}
                            />
                        </Form.Group>
                    </div>

                </div>
            </Card.Body>
        </Card>;
    }

    function getItemForm() {
        return <>
            <div className="row">
                <div className="col col-12 col-xl-6">
                    {getBasicInfo()}<br/>
                    {getBillingInfo()}
                </div>
                <div className="col col-12 col-xl-6">
                    {getMedicalInfo()}
                </div>
                <div className="col col-12">
                    <div className="pt-5">
                        <Button className="text-white" variant="info" type="submit" onClick={handleSubmit}>

                            {loading &&
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                    </div>
                                </div>
                            }
                            {!loading && <>Save</>}
                        </Button>
                    </div>
                    {successMessage &&
                        <div className="text-success fs-5">{successMessage}</div>
                    }
                    {errorMessage &&
                        <div className="text-danger fs-5">{errorMessage}</div>
                    }
                </div>
            </div>
        </>
    }


    return (
        <>
            {getItemForm()}
        </>
    );
};
